import produce from 'immer';
import {
  GET_SUBSCRIPTION_SETUP_START,
  GET_SUBSCRIPTION_SETUP_SUCCESS,
  GET_SUBSCRIPTION_SETUP_FAILED,
  UPDATE_SUBSCRIPTION_SETUP_START,
  UPDATE_SUBSCRIPTION_SETUP_SUCCESS,
  UPDATE_SUBSCRIPTION_SETUP_FAILED,
  GET_ADDITIONAL_SKUS_START,
  GET_ADDITIONAL_SKUS_SUCCESS,
  GET_ADDITIONAL_SKUS_FAILED,
  CREATE_ADDITIONAL_SKUS_START,
  CREATE_ADDITIONAL_SKUS_SUCCESS,
  CREATE_ADDITIONAL_SKUS_FAILED,
  EDIT_ADDITIONAL_SKUS_START,
  EDIT_ADDITIONAL_SKUS_SUCCESS,
  EDIT_ADDITIONAL_SKUS_FAILED,
  DELETE_ADDITIONAL_SKUS_START,
  DELETE_ADDITIONAL_SKUS_SUCCESS,
  DELETE_ADDITIONAL_SKUS_FAILED,
  GET_ADDITIONAL_SPECIALS_START,
  GET_ADDITIONAL_SPECIALS_SUCCESS,
  GET_ADDITIONAL_SPECIALS_FAILED,
  CREATE_ADDITIONAL_SPECIALS_START,
  CREATE_ADDITIONAL_SPECIALS_SUCCESS,
  CREATE_ADDITIONAL_SPECIALS_FAILED,
  EDIT_ADDITIONAL_SPECIALS_START,
  EDIT_ADDITIONAL_SPECIALS_SUCCESS,
  EDIT_ADDITIONAL_SPECIALS_FAILED,
  DELETE_ADDITIONAL_SPECIALS_START,
  DELETE_ADDITIONAL_SPECIALS_SUCCESS,
  DELETE_ADDITIONAL_SPECIALS_FAILED,
  GET_ADDITIONAL_FEATURES_START,
  GET_ADDITIONAL_FEATURES_SUCCESS,
  GET_ADDITIONAL_FEATURES_FAILED,
  CREATE_ADDITIONAL_FEATURES_START,
  CREATE_ADDITIONAL_FEATURES_SUCCESS,
  CREATE_ADDITIONAL_FEATURES_FAILED,
  EDIT_ADDITIONAL_FEATURES_START,
  EDIT_ADDITIONAL_FEATURES_SUCCESS,
  EDIT_ADDITIONAL_FEATURES_FAILED,
  DELETE_ADDITIONAL_FEATURES_START,
  DELETE_ADDITIONAL_FEATURES_SUCCESS,
  DELETE_ADDITIONAL_FEATURES_FAILED,
  CREATE_MARKETING_BILLING_START,
  CREATE_MARKETING_BILLING_SUCCESS,
  CREATE_MARKETING_BILLING_FAILED,
  CHANGE_ONBOARDING_DATA,
  SAVE_ONBOARDING_DATA_START,
  SAVE_ONBOARDING_DATA_SUCCESS,
  SAVE_ONBOARDING_DATA_FAILED,
  CHANGE_MARKETING_DATA,
  SAVE_MARKETING_DATA_START,
  SAVE_MARKETING_DATA_SUCCESS,
  SAVE_MARKETING_DATA_FAILED,
  GET_SUBSCRIPTION_BENEFITS_START,
  GET_SUBSCRIPTION_BENEFITS_SUCCESS,
  GET_SUBSCRIPTION_BENEFITS_FAILED,
  CREATE_SUBSCRIPTION_BENEFIT_START,
  CREATE_SUBSCRIPTION_BENEFIT_SUCCESS,
  CREATE_SUBSCRIPTION_BENEFIT_FAILED,
  UPDATE_SUBSCRIPTION_BENEFIT_START,
  UPDATE_SUBSCRIPTION_BENEFIT_SUCCESS,
  UPDATE_SUBSCRIPTION_BENEFIT_FAILED,
  DELETE_SUBSCRIPTION_BENEFIT_START,
  DELETE_SUBSCRIPTION_BENEFIT_SUCCESS,
  DELETE_SUBSCRIPTION_BENEFIT_FAILED,
  BILL_STORE_FROM_ONBOARDING_START,
  BILL_STORE_FROM_ONBOARDING_SUCCESS,
  BILL_STORE_FROM_ONBOARDING_FAILED,
} from '../actions/subscription';
import {
  GET_USER_PROFILE_START,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_FAILED
} from '../actions/user';


const initialState = {
  userProfile: {
    onboarding: {
      activeStep: 1
    },
    marketing: {},
  },
  subscriptionSetup: {},
  additionalSkus: [],
  additionalSpecials: [],
  additionalFeatures: [],
  subscriptionBenefits: {
    annually: [],
    semiAnnually: [],
    monthly: [],
  },
  isLoadingUserProfile: false,
  isLoadingSubscriptionSetup: false,
  isLoadingAdditionalSkus: false,
  isLoadingAdditionalFeatures: false,
  isLoadingAdditionalSpecials: false,
  isLoadingMarketingBilling: false,
  isLoadingMarketignData: false,
  isLoadingSubscriptionBenefits: false,
};

const formReducer = produce((state: ISubscriptionState = initialState, action) => {
  switch (action.type) {
    case GET_USER_PROFILE_START: {
      state.isLoadingUserProfile = true;
      break;
    }

    case GET_USER_PROFILE_SUCCESS: {
      const {user} = action.data;

      if (user.onboarding.activeStep > 5) {
        state.userProfile = {...user, onboarding: {...user.onboarding, activeStep: 5}};
      } else {
        state.userProfile = user;
      }

      state.isLoadingUserProfile = false;
      break;
    }

    case GET_USER_PROFILE_FAILED: {
      state.isLoadingUserProfile = false;
      break;
    }
    case GET_SUBSCRIPTION_SETUP_START: {
      state.isLoadingSubscriptionSetup = true;
      break;
    }
    case GET_SUBSCRIPTION_SETUP_SUCCESS: {
      const {subscriptionSetup} = action.data;

      state.subscriptionSetup = subscriptionSetup;
      state.isLoadingSubscriptionSetup = false;
      break;
    }
    case GET_SUBSCRIPTION_SETUP_FAILED: {
      state.isLoadingSubscriptionSetup = false;
      break;
    }

    case UPDATE_SUBSCRIPTION_SETUP_START: {
      state.isLoadingSubscriptionSetup = true;
      break;
    }
    case UPDATE_SUBSCRIPTION_SETUP_SUCCESS: {
      const {subscriptionSetup} = action.data;

      state.subscriptionSetup = subscriptionSetup;
      state.isLoadingSubscriptionSetup = false;
      break;
    }
    case UPDATE_SUBSCRIPTION_SETUP_FAILED: {
      state.isLoadingSubscriptionSetup = false;
      break;
    }
    case GET_ADDITIONAL_SKUS_START: {
      state.isLoadingAdditionalSkus = true;
      break;
    }
    case GET_ADDITIONAL_SKUS_SUCCESS: {
      const {data} = action;

      state.additionalSkus = data.sort((a, b) => a.order - b.order);
      state.isLoadingAdditionalSkus = false;
      break;
    }
    case GET_ADDITIONAL_SKUS_FAILED: {
      state.isLoadingAdditionalSkus = false;
      break;
    }
    case CREATE_ADDITIONAL_SKUS_START: {
      state.isLoadingAdditionalSkus = true;
      break;
    }
    case CREATE_ADDITIONAL_SKUS_SUCCESS: {
      const {data} = action.data;

      state.additionalSkus = [...state.additionalSkus, data].sort((a, b) => a.order - b.order);
      state.isLoadingAdditionalSkus = false;
      break;
    }
    case CREATE_ADDITIONAL_SKUS_FAILED: {
      state.isLoadingAdditionalSkus = false;
      break;
    }
    case EDIT_ADDITIONAL_SKUS_START: {
      state.isLoadingAdditionalSkus = true;
      break;
    }
    case EDIT_ADDITIONAL_SKUS_SUCCESS: {
      const {data} = action.data;

      state.additionalSkus = state.additionalSkus
        .map((el) => el._id === data._id ? data : el)
        .sort((a, b) => a.order - b.order);
      state.isLoadingAdditionalSkus = false;
      break;
    }
    case EDIT_ADDITIONAL_SKUS_FAILED: {
      state.isLoadingAdditionalSkus = false;
      break;
    }
    case DELETE_ADDITIONAL_SKUS_START: {
      state.isLoadingAdditionalSkus = true;
      break;
    }
    case DELETE_ADDITIONAL_SKUS_SUCCESS: {
      const {data} = action;

      state.additionalSkus = state.additionalSkus.filter((el) => el._id !== data);
      state.isLoadingAdditionalSkus = false;
      break;
    }
    case DELETE_ADDITIONAL_SKUS_FAILED: {
      state.isLoadingAdditionalSkus = false;
      break;
    }
    case GET_ADDITIONAL_SPECIALS_START: {
      state.isLoadingAdditionalSpecials = true;
      break;
    }
    case GET_ADDITIONAL_SPECIALS_SUCCESS: {
      const {data} = action;

      state.additionalSpecials = data.sort((a, b) => a.order - b.order);
      state.isLoadingAdditionalSpecials = false;
      break;
    }
    case GET_ADDITIONAL_SPECIALS_FAILED: {
      state.isLoadingAdditionalSpecials = false;
      break;
    }
    case CREATE_ADDITIONAL_SPECIALS_START: {
      state.isLoadingAdditionalSpecials = true;
      break;
    }
    case CREATE_ADDITIONAL_SPECIALS_SUCCESS: {
      const {data} = action.data;

      state.additionalSpecials = [...state.additionalSpecials, data].sort((a, b) => a.order - b.order);
      state.isLoadingAdditionalSpecials = false;
      break;
    }
    case CREATE_ADDITIONAL_SPECIALS_FAILED: {
      state.isLoadingAdditionalSpecials = false;
      break;
    }
    case EDIT_ADDITIONAL_SPECIALS_START: {
      state.isLoadingAdditionalSpecials = true;
      break;
    }
    case EDIT_ADDITIONAL_SPECIALS_SUCCESS: {
      const {data} = action.data;

      state.additionalSpecials = state.additionalSpecials
        .map((el) => el._id === data._id ? data : el)
        .sort((a, b) => a.order - b.order);
      state.isLoadingAdditionalSpecials = false;
      break;
    }
    case EDIT_ADDITIONAL_SPECIALS_FAILED: {
      state.isLoadingAdditionalSpecials = false;
      break;
    }
    case DELETE_ADDITIONAL_SPECIALS_START: {
      state.isLoadingAdditionalSpecials = true;
      break;
    }
    case DELETE_ADDITIONAL_SPECIALS_SUCCESS: {
      const {data} = action;

      state.additionalSpecials = state.additionalSpecials.filter((el) => el._id !== data);
      state.isLoadingAdditionalSpecials = false;
      break;
    }
    case DELETE_ADDITIONAL_SPECIALS_FAILED: {
      state.isLoadingAdditionalSpecials = false;
      break;
    }
    case GET_ADDITIONAL_FEATURES_START: {
      state.isLoadingAdditionalFeatures = true;
      break;
    }
    case GET_ADDITIONAL_FEATURES_SUCCESS: {
      const {data} = action;

      state.additionalFeatures = data.sort((a, b) => a.order - b.order);
      state.isLoadingAdditionalFeatures = false;
      break;
    }
    case GET_ADDITIONAL_FEATURES_FAILED: {
      state.isLoadingAdditionalFeatures = false;
      break;
    }
    case CREATE_ADDITIONAL_FEATURES_START: {
      state.isLoadingAdditionalFeatures = true;
      break;
    }
    case CREATE_ADDITIONAL_FEATURES_SUCCESS: {
      const {data} = action.data;

      state.additionalFeatures = [...state.additionalFeatures, data].sort((a, b) => a.order - b.order);
      state.isLoadingAdditionalFeatures = false;
      break;
    }
    case CREATE_ADDITIONAL_FEATURES_FAILED: {
      state.isLoadingAdditionalFeatures = false;
      break;
    }
    case EDIT_ADDITIONAL_FEATURES_START: {
      state.isLoadingAdditionalFeatures = true;
      break;
    }
    case EDIT_ADDITIONAL_FEATURES_SUCCESS: {
      const {data} = action.data;

      state.additionalFeatures = state.additionalFeatures
        .map((el) => el._id === data._id ? data : el)
        .sort((a, b) => a.order - b.order);

      state.isLoadingAdditionalFeatures = false;
      break;
    }
    case EDIT_ADDITIONAL_FEATURES_FAILED: {
      state.isLoadingAdditionalFeatures = false;
      break;
    }
    case DELETE_ADDITIONAL_FEATURES_START: {
      state.isLoadingAdditionalFeatures = true;
      break;
    }
    case DELETE_ADDITIONAL_FEATURES_SUCCESS: {
      const {data} = action;

      state.additionalFeatures = state.additionalFeatures.filter((el) => el._id !== data);
      state.isLoadingAdditionalFeatures = false;
      break;
    }
    case DELETE_ADDITIONAL_FEATURES_FAILED: {
      state.isLoadingAdditionalFeatures = false;
      break;
    }
    case CREATE_MARKETING_BILLING_START: {
      state.isLoadingMarketingBilling = true;
      break;
    }
    case CREATE_MARKETING_BILLING_SUCCESS: {
      state.isLoadingMarketingBilling = false;
      break;
    }
    case CREATE_MARKETING_BILLING_FAILED: {
      state.isLoadingMarketingBilling = false;
      break;
    }
    case CHANGE_ONBOARDING_DATA: {
      const {data} = action;
      state.userProfile.onboarding = data;
      break;
    }
    case SAVE_ONBOARDING_DATA_START: {
      state.isLoadingUserProfile = true;
      break;
    }
    case SAVE_ONBOARDING_DATA_SUCCESS: {
      const {onboarding} = action.data;
      state.userProfile.onboarding = onboarding;
      state.isLoadingUserProfile = false;
      break;
    }
    case SAVE_ONBOARDING_DATA_FAILED: {
      state.isLoadingUserProfile = false;
      break;
    }
    case SAVE_MARKETING_DATA_START: {
      state.isLoadingMarketignData = true;
      break;
    }
    case SAVE_MARKETING_DATA_SUCCESS: {
      const {marketing} = action.data;
      state.userProfile.marketing = marketing;
      state.isLoadingMarketignData = false;
      break;
    }
    case SAVE_MARKETING_DATA_FAILED: {
      state.isLoadingMarketignData = false;
      break;
    }
    case CHANGE_MARKETING_DATA: {
      const {data} = action;
      state.userProfile.marketing = data;
      break;
    }
    case GET_SUBSCRIPTION_BENEFITS_START: {
      state.isLoadingSubscriptionBenefits = true;
      break;
    }
    case GET_SUBSCRIPTION_BENEFITS_SUCCESS: {
      const {data} = action;

      state.subscriptionBenefits = data;
      state.isLoadingSubscriptionBenefits = false;
      break;
    }
    case GET_SUBSCRIPTION_BENEFITS_FAILED: {
      state.isLoadingSubscriptionBenefits = false;
      break;
    }
    case CREATE_SUBSCRIPTION_BENEFIT_START: {
      state.isLoadingSubscriptionBenefits = true;
      break;
    }
    case CREATE_SUBSCRIPTION_BENEFIT_SUCCESS: {
      const {data} = action.data;
      state.subscriptionBenefits[data.period] = [...state.subscriptionBenefits[data.period], data];
      state.isLoadingSubscriptionBenefits = false;
      break;
    }
    case CREATE_SUBSCRIPTION_BENEFIT_FAILED: {
      state.isLoadingSubscriptionBenefits = false;
      break;
    }
    case UPDATE_SUBSCRIPTION_BENEFIT_START: {
      state.isLoadingSubscriptionBenefits = true;
      break;
    }
    case UPDATE_SUBSCRIPTION_BENEFIT_SUCCESS: {
      const {data} = action.data;
      const prevList = state.subscriptionBenefits[data.period];
      const isPeriodTheSame = prevList.find((item) => item._id === data._id);

      if (isPeriodTheSame) {
        state.subscriptionBenefits[data.period] = prevList.map((item) => item._id === data._id ? data : item);
      } else {
        state.subscriptionBenefits.annually = state.subscriptionBenefits.annually.filter((i) => i._id !== data._id);
        state.subscriptionBenefits.semiAnnually = state.subscriptionBenefits.semiAnnually.filter((i) => i._id !== data._id);
        state.subscriptionBenefits.monthly = state.subscriptionBenefits.monthly.filter((i) => i._id !== data._id);
        state.subscriptionBenefits[data.period] = [...state.subscriptionBenefits[data.period], data];
      }

      state.isLoadingSubscriptionBenefits = false;
      break;
    }
    case UPDATE_SUBSCRIPTION_BENEFIT_FAILED: {
      state.isLoadingSubscriptionBenefits = false;
      break;
    }
    case DELETE_SUBSCRIPTION_BENEFIT_START: {
      state.isLoadingSubscriptionBenefits = true;
      break;
    }
    case DELETE_SUBSCRIPTION_BENEFIT_SUCCESS: {
      const {item} = action;
      const prevList = state.subscriptionBenefits[item.period];
      state.subscriptionBenefits[item.period] = prevList.filter((i) => i._id !== item._id);
      state.isLoadingSubscriptionBenefits = false;
      break;
    }
    case DELETE_SUBSCRIPTION_BENEFIT_FAILED: {
      state.isLoadingSubscriptionBenefits = false;
      break;
    }

    case BILL_STORE_FROM_ONBOARDING_START: {
      state.isLoadingMarketignData = true;
      break;
    }

    case BILL_STORE_FROM_ONBOARDING_SUCCESS: {
      window.location.href = '/';
      state.isLoadingMarketignData = false;
      break;
    }

    case BILL_STORE_FROM_ONBOARDING_FAILED: {
      state.isLoadingMarketignData = false;
      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
